import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CountryManagementService } from '../../../service/country-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { GlobalLocations, LocalService } from '../../../service/local.service';
import { LocationManagementService } from '../../../service/location-management.service';

@Component({
  selector: 'app-global-locations',
  templateUrl: './global-locations.component.html',
  styleUrls: ['./global-locations.component.scss']
})
export class GlobalLocationsComponent implements OnInit {
  @Input() locations: GlobalLocations;
  lstSectionConfigKeys: string[] = ["local_locations"]; @Output() onChanged = new EventEmitter();
  @Input() IsShowPostalCode = false; @Input() isExpand = true; @Input() isVertical = false; @Input() maxLevelLimit = 4;
  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private locationManagementService: LocationManagementService, private countryManagementService: CountryManagementService) { }

  ngOnInit(): void {
    //this.isExpand = this.localService.windowWidth > 900;
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    if (this.locations)
      this.onSetDefaults();
    else
      this.onLoad();
  }

  onLoad() {
    this.locationManagementService.getGlobalLocations().subscribe(result => {
      this.locations = result;
      this.onChanged.emit(this.locations.selected);
      this.onSetDefaults();
    });
  }

  onLanguageChanged() {
    this.onLocationChanged(1, true);
    this.onLocationChanged(2, true);
    this.onLocationChanged(3, true);
  }

  onSetDefaults() {
    if (this.locations.selected.v1 && this.locations.states.contents.length == 0 && this.maxLevelLimit > 1)
      this.onLocationChanged(1, true);
    if (this.locations.selected.v2 && this.locations.districts.contents.length == 0 && this.maxLevelLimit > 2)
      this.onLocationChanged(2, true);
    if (this.locations.selected.v3 && this.locations.constituencies.contents.length == 0 && this.maxLevelLimit > 3)
      this.onLocationChanged(3, true);
  }

  onLocationChanged(index, isOnlyLoad = false) {
    switch (index) {
      case 1: {
        this.countryManagementService.getCountryCode(this.locations.selected.v1).subscribe(result => {
          this.locations.selected.key = result.value;
          this.onGetChildLocation(isOnlyLoad);
        });
      } break;
      case 2: {
        this.locationManagementService.getChildLocations(this.locations.selected.v2, this.locations.selected.key).subscribe(result => {
          if (!isOnlyLoad) {
            this.locations.selected.v3 = '';
            this.locations.selected.v4 = '';
            this.locations.selected.v5 = '';
            this.locations.constituencies.contents = [];
          }
          this.locations.districts.contents = result.contents;
          if (!isOnlyLoad)
            this.onChanged.emit(this.locations.selected);
        });
      } break;
      case 3: {
        this.locationManagementService.getChildLocations(this.locations.selected.v3, this.locations.selected.key).subscribe(result => {
          if (!isOnlyLoad) {
            this.locations.selected.v4 = '';
            this.locations.selected.v5 = '';
          }
          this.locations.constituencies.contents = result.contents;
          if (!isOnlyLoad)
            this.onChanged.emit(this.locations.selected);
        });
      } break;
      case 4: {
        if (!isOnlyLoad)
          this.onChanged.emit(this.locations.selected);
      } break;
      case 5: {
        this.onChanged.emit(this.locations.selected);
      } break;
    }
  }

  onGetChildLocation(isOnlyLoad) {
    this.locationManagementService.getChildLocations(this.locations.selected.v1, this.locations.selected.key).subscribe(result => {
      if (!isOnlyLoad) {
        this.locations.selected.v2 = '';
        this.locations.selected.v3 = '';
        this.locations.selected.v4 = '';
        this.locations.selected.v5 = '';
        this.locations.districts.contents = [];
        this.locations.constituencies.contents = [];
      }
      this.locations.states.contents = result.contents;

      if (!isOnlyLoad)
        this.onChanged.emit(this.locations.selected);
    });
  }

  onToggleExpand() {
    this.isExpand = !this.isExpand;
  }

  onRemoveLocation(index) {
    this.locations.selected.v5 = '';
    switch (index) {
      case 1: {
        this.locations.selected.v2 = '';
        this.locations.selected.v3 = '';
        this.locations.selected.v4 = '';
        this.locations.selected.v5 = '';
        this.locations.districts.contents = [];
        this.locations.constituencies.contents = [];
        this.onChanged.emit(this.locations.selected);
      } break;
      case 2: {
        this.locations.selected.v3 = '';
        this.locations.selected.v4 = '';
        this.locations.selected.v5 = '';
        this.locations.constituencies.contents = [];
        this.onChanged.emit(this.locations.selected);
      } break;
      case 3: {
        this.locations.selected.v4 = '';
        this.locations.selected.v5 = '';
        this.onChanged.emit(this.locations.selected);
      } break;
    }
  }
}
